/** Persisted IDs: existing strategies keep their original meaning. */
export const OttopilotEventContainerDedupeStrategy = {
    geographyLevel: "28fc2608-ba0b-4cac-acd2-89686caddd16",
    liveDisposition: "622f7b46-5b17-4be1-8858-790d88bfd196",
    liveStatus: "a1b2c3d4-5e6f-4a7b-8c9d-0e1f2a3b4c5d",
    noDedupe: "16a3ec55-2e07-45ac-8506-3f1e63745c6a",
    organizationalUnitLevel: "1365047e-5716-482c-8fa9-f39fbbfb471a",
} as const;
